import { rules } from "@/common/tender/rules";
import { ElMessageBox } from "element-plus";
import store from "@store/tender";
import { h } from "vue";
import { accSub, accAdd } from "@/common/js/utils";
import { tenderProjectConfig } from "@store/tender/modules/waterStore";
/* 是否在省监督平台报建及备案 */
const IS_REPORT = (obj, args, form) => {
  let key = obj.Key;
  if (form[key]) {
    form.isReport = "是";
    form.isReportProvince = "是";
    form.IS_REPORT_PROVINCE = true;
    form.select_IS_REPORT_PROVINCE = "是";
  } else {
    form.isReport = "否";
    form.isReportProvince = "否";
    form.IS_REPORT_PROVINCE = false;
    form.select_IS_REPORT_PROVINCE = "否";

    form.REPORT_NUMBER = "";
    form.RECORD_NUMBER = "";

    form.PROJECT_NAME_disabled = false;
    form.REVIEW_STATUS = "";
    form.REVIEW_COMMENT = "";
  }
};
/* 项目类别关联代码 */
const RELATE_CODE = (obj, args, form, config) => {
  let key = obj.Key;
  // console.log(config, form["RELATE_CODE"]);
  if (form["RELATE_CODE"] === "0") {
    config["/0/section-03"].INVEST_PROJECT_CODE.Required = false;
  } else {
    config["/0/section-03"].INVEST_PROJECT_CODE.Required = true;
  }
};
/* 是否重新招标 */
const IS_REBID = (obj, args, form, config) => {
  let key = obj.Key;
  // console.log(config["/0/section-03"].REBID_TENDER_PROJECT_CODE);
  if (form["IS_REBID"] == "0") {
    form.REBID_TENDER_PROJECT_CODE = "";
    config["/0/section-03"].REBID_TENDER_PROJECT_CODE.Required = false;
    config["/0/section-03"].REBID_TENDER_PROJECT_CODE.Disabled = true;
  } else {
    config["/0/section-03"].REBID_TENDER_PROJECT_CODE.Required = true;
    config["/0/section-03"].REBID_TENDER_PROJECT_CODE.Disabled = false;
  }
};
/* 最高控制价 */
const CONTROL_PRICE = (obj, args, form, config) => {
  let key = obj.Key;
  // console.log(obj, args, form, config, 1111);

  if (form[key] != "" && (form[key] < 10000 || form[key] > 1000000000)) {
    let msg = form[key] < 10000 ? "少于1万元" : "超过10亿元";

    ElMessageBox({
      title: "提示",
      type: "waning",
      closeOnClickModal: false,
      message: h("p", { style: "font-weight:bolder;line-height:32px;font-size:16px;" }, [
        h("span", {}, "您填写的字段单位是"),
        h("span", { style: "color:red;" }, "元"),
        h("span", {}, "，当前输入金额"),
        h("span", { style: "color:red;" }, msg),
        h("span", {}, "，请确认金额是否正确，正确则忽略本条提示，不正确请自行修改为正确金额"),
      ]),
      showCancelButton: false,
      confirmButtonText: "已了解",
    }).then(() => {});
    // CONTROL_PRICE_debounce(msg);
  }

  if (form[key] == "") {
    form.COMPETITION_PRICE = "";
    form.NON_COMPETITION_PRICE = "";
  }
};
/* 业绩要求 */
const ACHIEVEMENT_REQUIRE = (obj, args, form, config) => {
  let key = obj.Key;

  /* 与第二章的近年完成的类似项目情况的时间要  有联动 */
  if (form["ACHIEVEMENT_REQUIRE"] === "要求") {
    config["/1/section-01"].ACHIEVEMENT_REQUIRE_CONTENT.Required = true;
    config["/1/section-01"].ACHIEVEMENT_REQUIRE_CONTENT.Disabled = false;
  } else {
    config["/1/section-01"].ACHIEVEMENT_REQUIRE_CONTENT.Required = false;
    config["/1/section-01"].ACHIEVEMENT_REQUIRE_CONTENT.Disabled = true;
    form.ACHIEVEMENT_REQUIRE_CONTENT = "";
  }
};

/* 赋予清空不可编辑的非必填操作 */
const clearAndRequiredAndDisabled = (obj, args, form, config) => {
  let key = obj.Key;
  // console.log(args);
  let chapter = args[0],
    judge = args[1],
    targetKeys = args[2],
    /* 兼容非必填的情况 */
    isRequired = args[3] !== undefined ? args[3] : false;
  if (form[key] == judge) {
    targetKeys.forEach((targetKey) => {
      config[chapter][targetKey] && (config[chapter][targetKey].Required = isRequired ? false : true);
      config[chapter][targetKey] && (config[chapter][targetKey].Disabled = false);
    });
  } else {
    targetKeys.forEach((targetKey) => {
      config[chapter][targetKey] && (config[chapter][targetKey].Required = isRequired ? false : false);
      config[chapter][targetKey] && (config[chapter][targetKey].Disabled = true);
      form[targetKey] = "";
      if (targetKey == "MARGIN_PAY_TYPE_label") {
        form[targetKey] = [];
      }
    });
  }
};
/* 招标人名称自动输入时回填其它数据 */
const TENDERER_NAME = (obj, args, form, config, autocompleteObject) => {
  if (!autocompleteObject) return;
  form.TENDERER_CODE = autocompleteObject.TENDERER_CODE || form.TENDERER_CODE;
  form.TENDERER_CORPORATE_IDENTITY = autocompleteObject.DERER_CORPORATE_IDENTITY || form.TENDERER_CORPORATE_IDENTITY;
};
/* 招标代理机构自动输入时回填其他数据 */
const TENDER_AGENCY_NAME = (obj, args, form, config, autocompleteObject) => {
  if (!autocompleteObject) return;
  form.TENDER_AGENCY_CODE = autocompleteObject.TENDER_AGENCY_CODE || form.TENDER_AGENCY_CODE;
  if (form.type == "施工" || form.type == "监理") {
    form.TENDER_AGENCY_ZIP_CODE =
      autocompleteObject.TENDER_AGENCY_ZIP_CODE ||
      autocompleteObject.TENDERER_AGENCY_LEGAL_ZIP_CODE ||
      autocompleteObject.TENDER_AGENCY_LEGAL_ZIP_CODE ||
      form.TENDER_AGENCY_ZIP_CODE;
  } else {
    form.TENDERER_AGENCY_LEGAL_ZIP_CODE =
      autocompleteObject.TENDERER_AGENCY_LEGAL_ZIP_CODE ||
      autocompleteObject.TENDER_AGENCY_ZIP_CODE ||
      autocompleteObject.TENDER_AGENCY_LEGAL_ZIP_CODE ||
      form.TENDERER_AGENCY_LEGAL_ZIP_CODE;
  }
};
/* 是否联合招标（其它章节中的补充字段） */
const ISUNION = (obj, args, form, config) => {
  let targetKeys = ["UNIONTENDER", "UNIONCODE", "UNIONCODETYPE", "XM_BID_SECTION_NUM"];
  let chapter = Object.keys(config)[Object.keys(config).length - 1];

  targetKeys.forEach((targetKey) => {
    config[chapter][targetKey].Required = form.ISUNION == "是";
  });
};
/* 价款形式代码（其它章节中的补充字段） */
const PRICE_FORM_CODE = (obj, args, form, config) => {
  let chapter = Object.keys(config)[Object.keys(config).length - 1];
  config[chapter]["MARGIN_PERCENT"].Required = form.PRICE_FORM_CODE != "1";
};
/* 标书费 */
const DOC_PRICE = (obj, args, form, config) => {
  // console.log(config["/0/section-03"].DOC_PRICE);
  /* 场内不需要标书费 */
  // console.log(form, form.regionId, 111);
  if (form.regionId && form.regionId.indexOf("x") != 0) {
    config["/0/section-03"].DOC_PRICE.Disabled = true;
    form.DOC_PRICE = "0.00";
  }
  if (form.DOC_PRICE === "0.00") {
    form.royalty_parameters = "";
    form.ROYALTY_REAL_NAME = "";
  }
};
/* 支付宝 */
const royalty_parameters = (obj, args, form, config) => {
  // console.log(obj, args, form, config, store);
  // if (isOnlySet) return false;
  if (form.regionId !== "x50002") return false; // 厦航执行
  const { AlipayAccounts } = store.state.selections;
  const value = form.royalty_parameters;
  if (value) {
    AlipayAccounts.forEach((obj) => {
      if (obj.Value === value) form.ROYALTY_REAL_NAME = obj.RealName;
    });
  } else {
    form.ROYALTY_REAL_NAME = "";
  }
};
/* 泉州 厦门 是否要求中标人提交履约保证金 限制为是且不可修改 */
const IS_PERFORMANCE_BOND = (obj, args, form, config) => {
  // console.log(obj, args, config, 222332);
  let chapter = args[0];
  // console.log(form, form.regionId, 222);
  if (form.regionId && (form.regionId.indexOf("3505") == 0 || form.regionId.indexOf("3502") == 0)) {
    form.IS_PERFORMANCE_BOND = "是";
    config[chapter].IS_PERFORMANCE_BOND.Disabled = true;
  }
};
/* 开标场地 */

const OPEN_BID_SITE = (obj, args, form, config) => {
  // form.SITE_BOOKING_NUM = "";
  // console.log(1112, form.OPEN_BID_SITE);
  form.SITE_BOOKING_NUM = "";
};
/* 远程异地评标 */
const ___RomoteEval___ = (obj, args, form, config) => {
  let key = obj.Key;
  if (form[key]) {
    ElMessageBox({
      title: "启用须知",
      type: "waning",
      closeOnClickModal: false,
      message: h("p", { style: "font-weight:bolder;line-height:32px;" }, [
        h(
          "p",
          { style: "font-weight:bolder;line-height:32px;" },
          "1、如在非随行易交易自建或合作单位（交易中心、企业等）的场地进行评标，则无法对该评标室进行全景监控；"
        ),
        h("p", { style: "font-weight:bolder;line-height:32px;" }, "2、请确保各个评标场所均具备可正常使用的语音麦克风与视频摄像头；"),
        h("p", { style: "font-weight:bolder;line-height:32px;" }, "3、专家总评报告需各场所专家自行签字并线下汇总。"),
      ]),
      showCancelButton: false,
      confirmButtonText: "已了解",
    }).then(() => {});
  }
};

export const customHooks = (type, obj, args, form, config, autocompleteObject) => {
  // console.log("😊", type);
  switch (type) {
    case "IS_REPORT":
      // validate_1(obj, params, form);
      IS_REPORT(obj, args, form);
      break;
    case "RELATE_CODE":
      RELATE_CODE(obj, args, form, config);
      break;
    case "IS_REBID":
      IS_REBID(obj, args, form, config);
      break;
    case "CONTROL_PRICE":
      CONTROL_PRICE(obj, args, form, config);
      break;
    case "ACHIEVEMENT_REQUIRE":
      ACHIEVEMENT_REQUIRE(obj, args, form, config);
      break;
    case "clearAndRequiredAndDisabled":
      clearAndRequiredAndDisabled(obj, args, form, config);
      break;
    case "TENDERER_NAME":
      TENDERER_NAME(obj, args, form, config, autocompleteObject);
    case "TENDER_AGENCY_NAME":
      TENDER_AGENCY_NAME(obj, args, form, config, autocompleteObject);
    case "ISUNION":
      ISUNION(obj, args, form, config);
      break;
    case "PRICE_FORM_CODE":
      PRICE_FORM_CODE(obj, args, form, config);
      break;
    case "DOC_PRICE":
      DOC_PRICE(obj, args, form, config);
      break;
    case "royalty_parameters":
      royalty_parameters(obj, args, form, config);
      break;
    case "IS_PERFORMANCE_BOND":
      IS_PERFORMANCE_BOND(obj, args, form, config);
      break;
    case "OPEN_BID_SITE":
      OPEN_BID_SITE(obj, args, form, config);
      break;
    case "___RomoteEval___":
      ___RomoteEval___(obj, args, form, config);
      break;
    default:
      callback();
      break;
  }
};

/* module.exports = {
  customHooks,
}; */
